import React from 'react';

const BaroPam = () => {
  return (
    <>
      <section className="baroPam">
        <div className="w1200">
          <div className="topTIt">
            <h2>BaroPAM 2차 인증 솔루션 </h2>
            <p>
              2차 인증으로 일회용 인증키를 접목시켜, <br className="w800" /> 단순하면서도 강력한
              정보자산의 접근제어가 가능한 솔루션
            </p>
          </div>
        </div>
        <div className="background">
          <div className="w1200">
            <div className="flex">
              <div className="image"></div>
              <div className="text">
                <h3>BaroPAM이란?</h3>
                <p>
                  BaroPAM은 기존의 정적 보안인 ID / PW를 이용한 <br className="w1170" /> Login
                  방식에&nbsp;
                  <span className="color">
                    동적 키(OTP)를
                    <br className="dis1170" /> 추가적으로 이용
                  </span>
                  하여
                  <br className="w1170" /> Login 할 수 있는 강력한 접근제어 인증 솔루션입니다.
                </p>
                <p>
                  해커가 접속 정보를 탈취 하더라도&nbsp;
                  <span className="color">
                    지속적으로 변경되는
                    <br className="w1170" /> 동적 키
                  </span>
                  로 인해
                  <br className="dis1170" /> 속이 불가능 하며&nbsp;
                  <span className="color line">
                    다양한 정보자산
                    <br className="w1170" /> (OS,Application,서버)에 적용
                  </span>
                  이 가능합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="advantages">
          <div className="w1200">
            <ul className="flex">
              <li>
                <figure>
                  <img src="/images/sub_baro_02.png" alt="" className="pc" />
                  <img src="/images/sub_baro_02_800.png" alt="" className="w800" />
                </figure>
                <p>
                  소프트웨어 모듈 방식으로 <br className="w750" /> 별도의 인증서버가 필요 없습니다.
                </p>
              </li>
              <li>
                <figure>
                  <img src="/images/sub_baro_03.png" alt="" className="pc" />
                  <img src="/images/sub_baro_03_800.png" alt="" className="w800" />
                </figure>
                <p>
                  스마트폰을 인증키 생성 매체로 사용하여
                  <br className="w750" /> 간단하고 편리합니다.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="method">
        <div className="w1200">
          <h2>인증 방식</h2>
          <p>
            정보자산 로그인 시 정적인 비밀번호 만으로는
            <br className="w400" /> 결코 안전하지 않으며,
            <br className="w1140" />
            매번 사용 시마다 비밀번호를 <br className="w400" /> 보완, 대체할 수 있는 인증이
            필요합니다.
            <br />
            <span className="blue">
              BaroPAM은 3가지 로그인 방식(추가인증, 비밀번호 대체,
              <br className="w1140" />
              새로운 비밀번호 생성)
            </span>
            을 적용할 수 있습니다.
          </p>
          <ul className="flex">
            <li>
              <h3>1안(추가인증)</h3>
              <figure>
                <img src="/images/sub_baro_04.png" alt="" />
              </figure>
              <p>
                로그인 ID, 비밀번호에 추가인증
                <br className="W385" /> (2차인증)으로 일회용 인증키 적용
              </p>
            </li>
            <li>
              <h3>2안(비밀번호 대체)</h3>
              <figure>
                <img src="/images/sub_baro_05.png" alt="" />
              </figure>
              <p>
                비밀번호 대신
                <br className="W385" /> 일회용 인증키로 대체
              </p>
            </li>
            <li>
              <h3>3안(새로운 생성)</h3>
              <figure>
                <img src="/images/sub_baro_06.png" alt="" />
              </figure>
              <p>
                비밀번호와 일회용 인증키를
                <br className="W385" /> 결합하여 새로운 비밀번호 생성
              </p>
            </li>
          </ul>
        </div>
      </section>
      <section className="appliesTo">
        <div className="w1200">
          <h2>적용 대상</h2>
          <ul className="flex">
            <li>
              <p>
                Desktop / Notebook <br /> (Windows, MacOS, 개방형OS)
              </p>
            </li>
            <li>
              <p>서버 / 네트워크 장비 외</p>
            </li>
            <li>
              <p>
                Application (ERP/그룹웨어/ <br /> 전자결제/포털사이트 외)
              </p>
            </li>
          </ul>
        </div>
      </section>
      <section className="baraFeatures">
        <div className="w1200">
          <h2>BaroPAM 특장점</h2>
          <div className="baroGrid">
            <div className="item">
              <h3>서버 및 OS, Application 보안 향상</h3>
              <p>
                512Bit 표준 Hash 함수를 사용하여 암호화 하므로 강력한 보안 제공
                <br className="w1220" /> 매번 변하는 키를 통해 동적 보안 제공
              </p>
            </div>
            <div className="item">
              <h3>유연한 연동 기능 제공</h3>
              <p>
                API 연동 기능 제공(C, Java 등)
                <br className="w385" /> 다양한 OS(Window,Linux,MacOS), 서버, Application에 적용
              </p>
            </div>
            <div className="item">
              <h3>빠르고 안정적인 서비스 제공</h3>
              <p>
                별도의 인증서버가 필요없는 모듈 인증 방식
                <br className="w385" /> 서버와 DB가 없으므로 장애 또는 부하가 발생하지 않음
              </p>
            </div>
            <div className="item">
              <h3>다양한 옵션 제공</h3>
              <p>
                화면 보호기 잠금 방지, 해제 기능 / 스마트폰 분실 시 앱 Look기능 /
                <br className="w1220" /> OTP 생성 주기 세분화 기능
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="comparison">
        <div className="w1200">
          <h2>경쟁사 비교</h2>
          <figure>
            <img src="/images/sub_baro_07.png" alt="" className="pc" />
            <img src="/images/sub_baro_07_400.png" alt="" className="w400" />
          </figure>
        </div>
      </section>
    </>
  );
};

export default BaroPam;
